/**
 *
 * Asynchronously loads the component for EditProfile
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
